import React from 'react';
import ReactModal from '../../../../components/Modal';
import { withTranslation } from 'react-i18next';

class ShowAllItemsModal extends React.Component {
    constructor(props) {
        super();

        this.onChangeSearch = this.onChangeSearch.bind(this);
        this.state = {
            search: '',
            searchedValues: props.data || [],
        };
    }

    onChangeSearch(e) {
        this.setState({
            search: e.target.value,
            searchedValues: this.props.data.filter((item) =>
                item.name.toLowerCase().includes(e.target.value.toLowerCase()),
            ),
        });
    }

    render() {
        const { t } = this.props;

        const activeItems = this.state.searchedValues?.filter(
            (item) => item.status === 'active',
        )?.length;

        return (
            <ReactModal
                modalState={this.props.isOpen}
                className="width-sm p-0"
                onClose={this.props.onClose}
            >
                <div className="ai-tracking-modal-show-all-items">
                    <div className="ai-tracking-modal-show-all-items-header">
                        <input
                            className="form-control"
                            value={this.state.search}
                            onChange={this.onChangeSearch}
                            placeholder={this.props.placeholder || 'Search...'}
                        />
                        <i className="icon-fi_search" />
                    </div>
                    <div className="p-12">
                        {t('ai_tracking.global.total')}: {this.state.searchedValues?.length},{' '}
                        {t('ai_tracking.global.active')}: {activeItems}
                    </div>
                    <div className="ai-tracking-modal-show-all-items-body">
                        {this.state.searchedValues?.map((item) =>
                            item.href ? (
                                <a
                                    key={item.name}
                                    href={item.href}
                                    className={`ai-tracking-modal-show-all-items-item ${
                                        item.status === 'inactive' ? 'inactive' : ''
                                    }`}
                                >
                                    {item.view ?? item.name}
                                </a>
                            ) : (
                                <div
                                    key={item.name}
                                    className={`ai-tracking-modal-show-all-items-item ${
                                        item.status === 'inactive' ? 'inactive' : ''
                                    }`}
                                >
                                    {item.view ?? item.name}
                                </div>
                            ),
                        )}
                        {this.state.searchedValues?.length === 0 && (
                            <div className="ai-tracking-modal-show-all-items-no-item">
                                {t('ai_tracking.global.no_items_found')}
                            </div>
                        )}
                    </div>
                </div>
            </ReactModal>
        );
    }
}

export default withTranslation()(ShowAllItemsModal);
